import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';
import { useQuery } from '@tanstack/react-query';
import type { ClientMedium } from '../types/clients';

export type ClientDetailsRecord = {
  id: string;
  name: string;
  phone: string;
  email: string | null;
  age: number | null;
  gender: string | null;
  avatar_url: string | null;
  status: 'lead' | 'active' | 'past' | 'cold';
  goal: string | null;
  progress_percentage: number | null;
  medical_medications: string | null;
  medical_allergies: string[];
  diet_type: string | null;
  work_hours: string | null;
  sleep_pattern: string | null;
  preferences_text: string | null;
  general_notes: string | null;
  medium: ClientMedium;
  archived_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  whatsapp_jid: string | null;
};

async function fetchClientDetails(
  clientId: string,
  accessToken: string | null | undefined,
) {
  return apiRequest<ClientDetailsRecord>(
    `/api/clients/${clientId}`,
    { method: 'GET' },
    accessToken,
  );
}

export function useClientDetails(clientId?: string) {
  const { session } = useAuth();

  return useQuery<ClientDetailsRecord>({
    queryKey: ['client', clientId],
    enabled: Boolean(clientId && session),
    queryFn: () => fetchClientDetails(clientId!, session?.access_token),
  });
}
